import React from "react";
import userProfile from "../../assets/img/userProfile.svg";
import alertsLogo from "assets/img/alerts.png";
import { IconMarin } from '../../views/popup/SvgSprite';
import { routes } from "routes/Routes";
import { withRouter } from "react-router-dom";
import { Drawer, Tooltip, Modal } from "antd";
import _authService from "modules/AuthService";
import ConfirmPopup from "../../views/popup/ConfirmPopup";
import ChangePassword from "../../views/popup/ChangePassword";
import {
  USER_NAME, PROFILE_URL, Last_LOGIN_DATETIME, PROJECT_LOGO
} from "constants/constants";
import moment from 'moment';
import _StudentService from "../../modules/StudentService";
import _branding from "modules/branding";

class PrivateHeader extends React.Component {
  constructor(props) {
    super(props);
    this.changePasswordModalRef = React.createRef();
    this.profileModalRef = React.createRef();
    this.analysisId = this.props.match.params.analysisId;
    this.state = {
      visible: false,
      ConfirmPopup: false,
      ChangePass: false,
      showProfileModal: false,
      notificationList: [],
      readCount: 0,
      unreadConut: 0,
      loading: false,
      username: localStorage[USER_NAME],
      profileURL: localStorage[PROFILE_URL],
      lastLoginDate: localStorage[Last_LOGIN_DATETIME]
    };
  }

  componentDidMount() {
    this.setState({
      lastLoginDate: moment(localStorage[Last_LOGIN_DATETIME]).calendar(),
      profileURL: localStorage[PROFILE_URL]
    });

    this.getAllNotifications();
  }

  //API operations
  getAllNotifications = async () => {
    try {
      this.setState({ loading: true }, async () => {
        try {
          let notificationListTemp = await _StudentService.getAllNotifications();
          //console.log("notification List Data: ", notificationListTemp);

          this.setState({
            ...this.state,
            notificationList: notificationListTemp.data.Notifications,
            readCount: notificationListTemp.data.ReadNotificationCount,
            unreadConut: notificationListTemp.data.UnReadNotificationCount,
            loading: false,
          });

        } catch (e) {
          // TODO
          this.setState({ loading: false });
          console.log('Error: ', e);
        }
      });
    } catch (e) { }
  }

  handleLogout(ConfirmPopup) {
    console.log("Handle Logout and redirect to landing page");
    _authService.logout();
  }

  ChangePass(ChangePass) {
    this.setState({ ChangePass });
    if (!ChangePass) {
      this.changePasswordModalRef.current.handleCancel();
    }
  }

  ConfirmPopup(ConfirmPopup) {
    this.setState({ ConfirmPopup });
  }

  logout = () => {
    _authService.logout();
  };

  UpdateStudentNotifications = () => {
    _StudentService.updateStudentNotifications();
    this.state.notificationList.map(item => {
      item.IsRead = true;
    })
    this.setState({ loading: false, unreadConut: 0 });
  }


  render() {
    return (
      <header className="privateHeaderMain">
        <div className="container-fluid">
          <nav className="navbar  navbar-expand-lg justify-content-between navbar-light p-0">
            {/* Phase C.7.2 (Candidate Experience Shell, §22 responsive foundation): this row's 3
                children were hardcoded to width:50%/50%/auto (inline styles, pre-existing) — fine
                while their combined content stayed narrow, but overflowed horizontally once this
                phase's own brand block + the existing bell/user-menu no longer fit 2×50%+auto at
                narrow viewports. Added ent-private-header-row/-col classes purely so the
                @media (max-width:575px) rule in themes.scss can override these 3 inline widths
                (`!important`, since inline styles otherwise win) — no inline style deleted, no
                markup reordered, so nothing changes above 575px. */}
            <div className="ent-private-header-row" style={{ display: 'inline-flex', width: '100%' }}>
              {/* <div style={{ width: '50%' }}>
                <a className="navbar-brand pl-2" href="" onClick={this.goToHome}>
                  <img src={projectLogo} className="projectLogo" />
                </a>
              </div> */}

              <div className="ent-private-header-col" style={{ width: '50%', justifyContent: 'start', display: 'flex' }}>
                {/* Phase C.7.2 (Branding Foundation): the logo now resolves through the same
                    _branding.resolveLogoUrl() priority chain as PublicHeader/the homepage (was a raw
                    localStorage['Portal_Logo'] read with NO fallback at all — a candidate could see a
                    broken image if that key was ever empty). Organization name is new here — this
                    header previously showed no recruitment identity text at all, unlike PublicHeader;
                    added for candidate-journey consistency (§12), not a new data source. */}
                <a className="navbar-brand pl-2 ent-private-header-brand" href="" style={{ justifyContent: "end" }} width="10">
                  <img src={_branding.resolveLogoUrl(localStorage['Portal_Logo'], PROJECT_LOGO)} className="projectLogo" alt="Portal Logo" style={{ alignSelf: 'center', cursor: "pointer" }} />
                  <span className="ent-private-header-org-name">{_branding.resolveOrganizationName("Enterprise Registration Platform")}</span>
                </a>
              </div>

              {/* <div style={{ width: '50%', justifyContent: 'end', display: 'flex' }}>
                <a className="navbar-brand pl-2" href="" style={{ justifyContent: "end" }} width="10">
                  <img src={alertsLogo} className="projectLogo" style={{ alignSelf: 'center', cursor: "pointer" }} />
                </a>
              </div> */}

              <div style={{ width: '50%', justifyContent: 'end', display: 'flex' }} className="dropdown ent-private-header-col">
                <a className="navbar-brand pl-2" href="" style={{ justifyContent: "end" }} id="navbardrop" data-toggle="dropdown">
                  <img src={alertsLogo} className={`projectLogo ${this.state.unreadConut > 0 ? 'blinkNotificationCount' : ''}`} alt="Notifications" style={{ alignSelf: 'center', cursor: "pointer" }} />
                  {this.state.unreadConut > 0 && <label className="labelNotificationCount blinkNotificationCount">{this.state.unreadConut}</label>}
                </a>
                <div className="topheaderdropdown dropdown-menu dropdown-menu-right NotificationDiv p-2 gl-bxbr customscrollBar" style={{ backgroundColor: '#fff' }}>
      
                    {this.state.notificationList.map((item, index) => (
                      <div key={index} className='NotificationItem'>
                        <div
                          className={`NotificationItemData ${item.IsRead ? '' : 'NotificationItemColor'}`}
                          onClick={this.UpdateStudentNotifications}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { this.UpdateStudentNotifications(); } }}
                        >
                          <IconMarin iconName={item.IsRead ? 'tick' : 'unread'} class="icon mr-2" />
                          {item.NotificationMessage}
                          <label>{moment(item.NotificationDateTime).isValid() ? moment(item.NotificationDateTime).format('DD MMM YYYY, h:mm a') : ""}</label>
                        </div>
                        <div className="dropdown-divider m-0"></div>
                      </div>
                    ))}
                    {this.state.notificationList.length == 0 &&
                    <>
                      <div className="dropdown-item p-0">
                        <div className=" dropdown-item p-2">
                          <IconMarin iconName="alert" class="icon mr-2" />
                          No New Notifications
                        </div>
                      </div>
                    </>
                  }
                 
                </div>
              </div>

              <div className="ent-private-header-col ent-private-header-col-user">
                <ul className="nav navbar-nav navbar-brand pl-2">
                  <li className="nav-item userInfo dropdown mr-sm-3">
                    <a
                      className="nav-link pt-0 pb-0 dropdown-toggle d-flex align-items-center"
                      href="#"
                      id="navbardrop"
                      data-toggle="dropdown"
                    >
                      <span className="userIconWrap mr-1 d-inline-flex align-items-center justify-content-center">
                        <img src={this.state.profileURL ? this.state.profileURL : userProfile} alt="Profile" height="25px" />
                      </span>
                      <span className="ml-2">
                        <label className="mb-0 useName">
                          {this.state.username}

                          <IconMarin iconName="down-arrow" fill="#fff" class="icon" />
                        </label>
                      </span>
                    </a>
                    <div className="topheaderdropdown dropdown-menu dropdown-menu-right ">
                      {/* <div className=" dropdown-item p-0">
                        <div
                          className=" dropdown-item p-2"
                          onClick={() => this.ChangePass(true)}
                        >
                          <IconMarin iconName="key" fill="#797979" class="icon mr-2" />
                          Change Password
                        </div>
                      </div>
                      <div className="dropdown-divider m-0"></div> */}
                      <div
                        className=" dropdown-item p-2"
                        onClick={() => this.ConfirmPopup(true)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { this.ConfirmPopup(true); } }}
                      >
                        <IconMarin iconName="logout-icon" fill="#797979" class="icon mr-2" />
                        Logout
                      </div>
                    </div>
                  </li>

                </ul>
              </div>
            </div>

            {/* <div id="navbarSupportedContent" className=" justify-content-end">
              
            </div> */}
          </nav>
        </div>
        <Modal
          centered={true}
          width={600}
          // bodyStyle={{ height: '250px', padding: 0, alignItems: 'center', justifyContent: 'center', display: ' flex' }}
          className="modelPopAnt"
          visible={this.state.ChangePass}
          onCancel={() => this.ChangePass(false)}
          footer={false}
        >
          <ChangePassword
            ref={this.changePasswordModalRef}
            resetPass={this.objStateUpdate}
            closeModal={() => this.ChangePass(false)}
          />{" "}
        </Modal>

        <Modal
          centered={true}
          width={400}
          // bodyStyle={{
          //   height: "150px",
          //   padding: 0,
          //   alignItems: "center",
          //   justifyContent: "center",
          //   display: " flex"
          // }}
          className="modelPopAnt"
          visible={this.state.ConfirmPopup}
          onCancel={() => this.ConfirmPopup(false)}
          footer={false}
        >
          <ConfirmPopup
            onCancel={() => this.ConfirmPopup(false)}
            onOk={this.logout}
            message="Are you sure, you want to logout?"
          />
        </Modal>
      </header>
    );
  }
}

export default withRouter(PrivateHeader);